import 'core-js/stable';
import 'regenerator-runtime';

const emailSubscribeForm = document.querySelector('.footer__newsletter');
const emailInput = emailSubscribeForm.querySelector('.email-to-subscribe');
const feedBackElem = emailSubscribeForm.querySelector('.email-subscribe-text');

console.log(feedBackElem);

emailSubscribeForm.addEventListener('submit', function (ev) {
   ev.preventDefault();

   const emailInput = this.querySelector('.email-to-subscribe');
   if (!emailInput.value) return;

   fetch('https://dgmmc-api.herokuapp.com/api/subscribe-email', {
      method: 'POST',
      body: JSON.stringify({ email: emailInput.value }),
      headers: {
         'Content-Type': 'application/json',
      },
   })
      .then((response) => response.json())
      .then((response) => {
         console.log('RESPONSE:', response);
         if (response.status === 'success') {
            feedBackElem.textContent = 'Sucessfully subscribed';
            feedBackElem.style.color = '#b1d82f';
            emailInput.value = '';
            return;
         }
         if (response.msg.includes('validation failed')) {
            feedBackElem.textContent = 'Invalid email entered';
            feedBackElem.style.color = '#cc3467';
            return;
         }
      })
      .catch((err) => {
         this.querySelector('.email-subscribe-text').textContent =
            "Couldn't register. Something went wrong";
      });
});

emailInput.addEventListener('focusout', () => {
   feedBackElem.textContent = 'Subscribe to our newsletter';
   feedBackElem.style.color = 'gray';
});
